import React, { useState } from "react";
import { formatAmount } from "../../helpers/quickbooks";
import Drawer from "../Drawer";

const TableRow = ({ entry, level = 0, openGroups, toggleGroup }) => {
  const hasChildren = Array.isArray(entry.items) && entry.items.length > 0;
  const isOpen = openGroups[entry.id];

  return (
    <React.Fragment>
      <tr
        className={`hover:bg-gray-100 cursor-${hasChildren ? "pointer" : "default"}`}
        onClick={() => hasChildren && toggleGroup(entry.id)}
      >
        <td className="py-3 text-sm font-medium text-gray-900 flex items-center gap-1">
          <div style={{ marginLeft: `${level * 16}px` }} className="flex items-center">
            {hasChildren && (
              <span className="text-gray-400 mr-1">
                {isOpen ? "▾" : "▸"}
              </span>
            )}
            {entry.name}
          </div>
        </td>
        <td className="py-3 text-sm text-gray-900 text-right">
          {formatAmount(entry.value)}
        </td>
      </tr>

      {hasChildren && isOpen && entry.items.map((subItem) => (
        <TableRow
          key={subItem.id}
          entry={subItem}
          level={level + 1}
          openGroups={openGroups}
          toggleGroup={toggleGroup}
        />
      ))}
    </React.Fragment>
  );
};

const CollapsibleTable = ({ data }) => {
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (id) => {
    setOpenGroups((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <table className="w-full">
      <thead>
        <tr className="border-b border-gray-200">
          <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider pb-2">Item</th>
          <th className="text-right text-xs font-medium text-gray-500 uppercase tracking-wider pb-2">Amount</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {(data || []).map((entry) => (
          <TableRow
            key={entry.id}
            entry={entry}
            openGroups={openGroups}
            toggleGroup={toggleGroup}
          />
        ))}
      </tbody>
    </table>
  );
};

export const ProfitReportSidebar = ({
    sidebarData,
    onClose
}) => {
    const title = sidebarData?.title || "";
    const items = sidebarData?.items || [];
    const total = sidebarData?.total || 0;
    const month = sidebarData?.month || "";

    if (!sidebarData) return null;

    return (
        <Drawer size={"sm"} isOpen={!!sidebarData} onClose={onClose} title={title || ""} showActionButtons={false}>
            <div className="p-6">
                <p className="text-sm text-gray-600 mb-4">{month}</p>
                <div className="bg-gray-50 rounded-lg p-4">
                    <CollapsibleTable data={items} />
                </div>
                <div className="mt-6 bg-blue-50 rounded-lg p-4">
                    <div className="flex justify-between items-center">
                        <span className="text-sm font-medium text-blue-900">Total for {month}</span>
                        <span className="text-lg font-bold text-blue-900">{formatAmount(total || 0)}</span>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};